import { render } from "./CreateAccountSideBar.vue?vue&type=template&id=89871a32"
import script from "./CreateAccountSideBar.vue?vue&type=script&lang=js"
export * from "./CreateAccountSideBar.vue?vue&type=script&lang=js"

import "./CreateAccountSideBar.vue?vue&type=style&index=0&id=89871a32&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__